export default __webpack_public_path__ + "static/media/about-vision.df1a5906.png";